export const adminControllerPath = '/admin/organizations/:organizationId/'
